export const MAXIMUM_Z_INDEX = Object.freeze(9999);
